import React from 'react';

// Matches the Varahi logo in the image: gold/green chevron arrow shape
const VarahiLogo = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Left dark green chevron */}
    <polygon points="4,38 18,8 22,16 12,38" fill="#0d3d2a" />
    {/* Right gold chevron */}
    <polygon points="22,8 36,38 26,38 18,18" fill="#c9a84c" />
    {/* Gold highlight tip */}
    <polygon points="18,8 22,8 22,16 18,18" fill="#e8c96a" />
  </svg>
);

export default VarahiLogo;
